<script setup lang="ts">
  import { useRouter } from 'vue-router'

  const router = useRouter()

  const goHome = () => {
    router.push('/')
  }
</script>

<template>
  <section class="min-h-[calc(100vh-200px)] flex items-center justify-center px-4">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-teal-600">404</h1>
      <div class="mt-4">
        <h2 class="text-2xl font-semibold text-gray-800">Página no encontrada</h2>
        <p class="mt-2 text-gray-600">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
      </div>
      <button
        class="mt-8 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50"
        @click="goHome"
      >
        Volver al inicio
      </button>
    </div>
  </section>
</template>
